module.exports = __webpack_public_path__ + "img/六门控制器 (4).a5a16c61.jpg";